module.exports = __webpack_public_path__ + "static/img/profile.6475909.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile.jpg
// module id = +rrE
// module chunks = 13